/* eslint-disable react-hooks/exhaustive-deps */
import { KTSVG } from '../../_metronic/helpers'
import React, { useState, useEffect } from 'react'
import { Table } from 'react-bootstrap-v5';
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom';
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import { useHistory } from "react-router-dom";
import { numberFormat } from '../helpers/GlobalHelper';

interface PurchaseRows {
    idPurchaseRows?: number;
    idItems: number;
    itemName?: string;
    poQuantity: number;
    receivedQuantity: number;
    quantity: number;
    returnQuantity: number;
    returnedQuantity?: number; // Previous returned quantity
    rate: number;
    amount: number;
    [key: string]: any; // Index signature
}

interface Item {
    idItems: number;
    itemName: string;
}

interface PurchaseData {
    idPurchase?: number;
    purchaseType: string;
    idProjects: number;
    idPo: number;
    idVendors: number;
    invoiceNo: string;
    idWarehouses?: number;
    purchaseDate: string;
    referenceNo: string;
    lcNo: string;
    chalanNo: string;
    chalanDate: string;
    remarks: string;
    purchaseAmount: number;
    vatPercentage: number;
    vatAmount: number;
    taxPercentage: number;
    taxAmount: number;
    creditDays?: number;
}

interface RouteParams {
    idPurchase: string;
}

const PurchaseEdit = () => {

    let history = useHistory();
    const { idPurchase }: RouteParams = useParams();

    const purchaseData: PurchaseData = {
        idPurchase: parseInt(idPurchase),
        purchaseType: "Local Purchase",
        idProjects: 0,
        idPo: 0,
        idVendors: 0,
        invoiceNo: '',
        purchaseDate: '',
        referenceNo: '',
        lcNo: '',
        chalanNo: '',
        chalanDate: '',
        remarks: '',
        purchaseAmount: 0,
        vatPercentage: 0,
        vatAmount: 0,
        taxPercentage: 0,
        taxAmount: 0,
        creditDays: 0
    };

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [po, setPo] = useState({ label: 'Select PO', value: '' });
    const [purchaseOrders, setPurchaseOrders] = useState([]);

    const [vendors, setVendors] = useState([]);
    const [vendor, setVendor] = useState({ label: 'Select Vendor', value: '' });
    const [purchase, setPurchase] = useState(purchaseData);
    const [purchaseRows, setPurchaseRows] = useState<PurchaseRows[]>([{
        idPurchaseRows: 0,
        idItems: 0,
        itemName: '',
        poQuantity: 0,
        receivedQuantity: 0,
        returnedQuantity: 0,
        quantity: 0,
        returnQuantity: 0,
        rate: 0,
        amount: 0,
    }]);
    
    const [items, setItems] = useState<Item[]>([]);
    // Warehouse dropdown state
    const [warehouses, setWarehouses] = useState([]);
    const [warehouse, setWarehouse] = useState({ label: 'Select Warehouse', value: '' });
 
    useEffect(() => {
        getProjects();
        getVendors();
        getItems();

        if (idPurchase !== undefined) {
            getPurchaseInfo();
        }
    }, [idPurchase]);

    // Load warehouses when project changes
    useEffect(() => {
        if (purchase.idProjects) {
            getWarehousesByProject(purchase.idProjects);
        }
    }, [purchase.idProjects]);
    
    // Recalculate VAT & TAX when purchaseRows change
    useEffect(() => {
        if (purchaseRows.length > 0) {
            const totalAmount = calculateTotalAmount();
            setPurchase((prev) => {
                const vatPercentage = prev.vatPercentage || 0;
                const taxPercentage = prev.taxPercentage || 0;
                const vatAmount = (totalAmount * Number(vatPercentage)) / 100;
                const taxAmount = (totalAmount * Number(taxPercentage)) / 100;
                const purchaseAmount = totalAmount + vatAmount + taxAmount;
                
                return {
                    ...prev,
                    vatAmount: vatAmount,
                    taxAmount: taxAmount,
                    purchaseAmount: purchaseAmount
                };
            });
        }
        // eslint-disable-next-line
    }, [purchaseRows]);
    // Fetch warehouses by project
    const getWarehousesByProject = (idProjects: number) => {
        if (!idProjects) {
            setWarehouses([]);
            setWarehouse({ label: 'Select Warehouse', value: '' });
            return;
        }
        fetch(
            process.env.REACT_APP_API_URL + 'warehouse/' + idProjects + '/list',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success && Array.isArray(resp.data)) {
                    const whOptions = resp.data.map((item: any) => ({
                        label: item.name,
                        value: item.id_warehouses
                    }));
                    setWarehouses(whOptions);
                    // If editing, try to set the selected warehouse from purchase
                    if (purchase.idWarehouses) {
                        const found = whOptions.find((w: any) => w.value === purchase.idWarehouses);
                        setWarehouse(found || { label: 'Select Warehouse', value: '' });
                    } else {
                        setWarehouse({ label: 'Select Warehouse', value: '' });
                    }
                } else {
                    setWarehouses([]);
                    setWarehouse({ label: 'Select Warehouse', value: '' });
                }
            })
            .catch(() => {
                setWarehouses([]);
                setWarehouse({ label: 'Select Warehouse', value: '' });
            });
    };

    const handleWarehouseChange = (selected: any) => {
        setWarehouse(selected);
        setPurchase({ ...purchase, idWarehouses: selected ? selected.value : '' });
    };

    const getPurchaseInfo = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'purchase/' + idPurchase + '/edit',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                const purchaseRes = {
                    ...purchase,
                    idPurchase: resp.data.id_purchase,
                    purchaseType: resp.data.purchaseType,
                    idProjects: resp.data.id_projects,
                    idPo: resp.data.id_po,
                    idVendors: resp.data.id_vendors,
                    purchaseDate: resp.data.purchaseDate,
                    referenceNo: resp.data.referenceNo,
                    lcNo: resp.data.lcNo,
                    invoiceNo: resp.data.invoiceNo || '',
                    chalanNo: resp.data.chalanNo,
                    chalanDate: resp.data.chalanDate,
                    remarks: resp.data.remarks,
                    purchaseAmount: Number(resp.data.purchaseAmount),
                    idWarehouses: resp.data.id_warehouses || '',
                    vatPercentage: Number(resp.data.vat || 0),
                    vatAmount: Number(resp.data.vatAmount || 0),
                    taxPercentage: Number(resp.data.tax || 0),
                    taxAmount: Number(resp.data.taxAmount || 0),
                    creditDays: resp.data.po?.creditDays || 0
                };
                setPurchase(purchaseRes);
                setProject({ label: resp.data.project.projectName, value: resp.data.id_projects });
                setVendor({ label: resp.data.vendor.vendorName, value: resp.data.id_vendors });
                setPo({ label: resp.data.po.referenceNo, value: resp.data.id_po });
                // Set warehouse dropdown value after warehouse list loads
                if (resp.data.id_warehouses) {
                    setWarehouse({ label: resp.data.warehouse?.name || 'Select Warehouse', value: resp.data.id_warehouses });
                }
                const rows = resp.data.rows.map((item: any) => {
                    // Find corresponding PO row to get poQuantity and previous quantities
                    const poRow = resp.data.po?.rows?.find((poItem: any) => poItem.id_po_rows === item.id_po_rows);
                    
                    const row: PurchaseRows = {
                        idPurchaseRows: item.id_purchase_rows,
                        idItems: item.id_items,
                        itemName: item.item.itemName,
                        poQuantity: poRow ? Number(poRow.poQuantity) : 0,
                        receivedQuantity: poRow ? Number(poRow.receivedQuantity) : 0,
                        returnedQuantity: poRow ? Number(poRow.returnedQuantity) : 0,
                        quantity: Number(item.quantity),
                        returnQuantity: Number(item.returnQuantity || 0),
                        rate: Number(item.rate),
                        amount: item.rate * item.quantity,
                    };
                    return row;
                });
                setPurchaseRows(rows);
                getProjectPurchase(resp.data.id_projects);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop');
            });
    };
    
    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getVendors = () => {

        fetch(
            process.env.REACT_APP_API_URL + 'vendors',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let leadObj = resp.data.map((item: any) => {
                    item.label = item.vendorName;
                    item.value = item.idVendors;
                    return item
                })
                setVendors(leadObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getProjectPurchase = (idProjects: number) => {

        fetch(
            process.env.REACT_APP_API_URL + 'purchase/po/' + idProjects+'?purchaseType='+purchase.purchaseType,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let poObj = resp.data.map((item: any) => {
                    item.label = item.referenceNo;
                    item.value = item.idPo;
                    return item
                })
                setPurchaseOrders(poObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleProjectChange = (project: any) => {
        setProject(project);
        setPurchase({ ...purchase, idProjects: project.value });
        getProjectPurchase(project.value);

    }

    const handlePoChange = (po: any) => {
        setPo(po);

        fetch(
            process.env.REACT_APP_API_URL + 'purchase/po-info/' + po.value,
            getRequestOptions()
        )
        .then((resp) => {
            return resp.json()
        })
        .then((resp) => {

            let poRows = [...resp.purchase.rows];
            poRows = poRows.map((row, index) => ({
                idPoRows: row.id_po_rows,
                idItems: row.id_items,
                itemName: row.item.itemName,
                itemCode: row.item.itemCode,
                poQuantity: Number(row.poQuantity),
                receivedQuantity: Number(row.receivedQuantity),
                returnedQuantity: Number(row.returnedQuantity || 0),
                quantity: Number(row.quantity),
                returnQuantity: Number(row.returnQuantity || 0),
                rate: Number(row.rate),
                amount: Number(row.quantity)*Number(row.rate)
            }));

            setVendor({ label: resp.purchase.vendor.vendorName, value: resp.purchase.id_vendors });
            
            // Auto-populate VAT & TAX from PO if available
            const vatPercentage = resp.purchase.vat || 0;
            const taxPercentage = resp.purchase.tax || 0;
            const creditDays = resp.purchase.creditDays || 0;
            
            setPurchase({ 
                ...purchase, 
                idPo: po.value, 
                lcNo: po.lcNo, 
                idVendors: resp.purchase.id_vendors,
                vatPercentage: vatPercentage,
                taxPercentage: taxPercentage,
                creditDays: creditDays
            });

            setPurchaseRows(poRows);
            console.log(poRows, 'poRows')

        })
        .catch((error) => {
            console.log(error, 'catch the hoop')
        })

    }

    const handleVendorChange = (vendor: any) => {
        setVendor(vendor);
        setPurchase({ ...purchase, idVendors: vendor.value });
    }

    const handleItemChange = (data: any, index: number) => {
        const updatedPurchaseRows = [...purchaseRows];
        updatedPurchaseRows[index].idItems = data.value;
        updatedPurchaseRows[index].rate = 0;
        setPurchaseRows(updatedPurchaseRows);
    }

    const getItems = () => {

        fetch(
            process.env.REACT_APP_API_URL + 'production-items',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {

                let items = resp.data.map((item: any) => {
                    item.label = item.itemName;
                    item.value = item.idItems;
                    return item
                })
                setItems(items);

            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedPurchaseRows = [...purchaseRows];
        updatedPurchaseRows[index][e.target.name] = e.target.value;

        const quantity = parseFloat(updatedPurchaseRows[index].quantity);
        const rate = parseFloat(updatedPurchaseRows[index].rate);
        updatedPurchaseRows[index].amount = parseFloat((quantity * rate).toFixed(2));
       
        setPurchaseRows(updatedPurchaseRows);
        // VAT & TAX will be recalculated by useEffect when purchaseRows changes
    }
    
    const handleVatOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const vatPercentage = parseFloat(event.target.value) || 0;
        calculateVatTax(vatPercentage, purchase.taxPercentage);
    }

    const handleTaxOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const taxPercentage = parseFloat(event.target.value) || 0;
        calculateVatTax(purchase.vatPercentage, taxPercentage);
    }
    
    const calculateVatTax = (vatPercent?: number, taxPercent?: number) => {
        const totalAmount = calculateTotalAmount();
        const vatPercentage = vatPercent !== undefined ? vatPercent : purchase.vatPercentage;
        const taxPercentage = taxPercent !== undefined ? taxPercent : purchase.taxPercentage;
        
        const vatAmount = (totalAmount * Number(vatPercentage)) / 100;
        const taxAmount = (totalAmount * Number(taxPercentage)) / 100;
        const purchaseAmount = totalAmount + vatAmount + taxAmount;
        
        setPurchase({
            ...purchase,
            vatPercentage: vatPercentage,
            taxPercentage: taxPercentage,
            vatAmount: vatAmount,
            taxAmount: taxAmount,
            purchaseAmount: purchaseAmount
        });
    }

    // eslint-disable-next-line
    const deleteItem = (index: number) => {
        const updatedPurchaseRows = [...purchaseRows];
        if (updatedPurchaseRows && updatedPurchaseRows[index]) {
            updatedPurchaseRows.splice(index, 1);
            setPurchaseRows(updatedPurchaseRows);
        }
    }

    // eslint-disable-next-line
    const addItem = (index: number) => {
        const newRow: PurchaseRows = {
            idPurchaseRows: 0,
            idItems: 0,
            poQuantity: 0,
            receivedQuantity: 0,
            returnedQuantity: 0,
            quantity: 0,
            returnQuantity: 0,
            rate: 0,
            amount: 0,
        };

        const updatedRows = [...purchaseRows];
        updatedRows.push(newRow);

        setPurchaseRows(updatedRows);
    }

    const handleInputOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPurchase({ ...purchase, [event.target.name]: event.target.value });
    }

    const handleSelectOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        if(event.target.id === 'purchaseType'){
            setPo({ label: 'Select PO', value: '' });
            setVendor({ label: 'Select Vendor', value: '' });
            setPurchaseOrders([]);
            setPurchase({ ...purchase, idPo: 0, lcNo: '', invoiceNo: '',  idVendors: 0 })
            setPurchaseRows([{
                idPoRows: 0,
                idItems: 0,
                poQuantity: 0,
                receivedQuantity: 0,
                returnedQuantity: 0,
                quantity: 0,
                returnQuantity: 0,
                rate: 0,
                amount: 0,
            }])
        }
        setPurchase({ ...purchase, [event.target.id]: event.target.value });
    };

    const calculateTotalAmount = () => {
        let totalAmount = 0;

        for (const row of purchaseRows) {
            totalAmount += row.amount;
        }
        return totalAmount;
    };

    const purchaseSave = async (event: any) => {
        event.preventDefault();
        // Ensure purchaseAmount is calculated with VAT & TAX
        const totalAmount = calculateTotalAmount();
        const vatAmount = (totalAmount * Number(purchase.vatPercentage || 0)) / 100;
        const taxAmount = (totalAmount * Number(purchase.taxPercentage || 0)) / 100;
        const purchaseAmount = totalAmount + vatAmount + taxAmount;
        setPurchase({ ...purchase, purchaseAmount: purchaseAmount, vatAmount: vatAmount, taxAmount: taxAmount });

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to update this Good Receive!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Update it!',
        });
        if (confirm.value) {
            const postData = {
                purchase: { ...purchase, idWarehouses: warehouse.value },
                purchaseRows: purchaseRows,
            };
            const requestOptions = postRequestOptions(postData);
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}purchase/update`,
                    requestOptions
                );
                let respData = await response.json();
                if (respData.success === true) {
                    const successMsg = respData.successMessage;
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    });
                    history.push("/purchase");
                } else {
                    const errorsMessage = validationErrorMsg(respData.errors).join('<br>');
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    });
                }
            } catch (error) {
                console.log(error, 'catch the hoop');
            }
        }
    };

    return (

        <div className="card card-custom">
            <div className="card-header">
                <div className="card-title">
                    <KTSVG
                        path='/media/svg/icons/Home/Book-open.svg'
                        className='svg-icon-1 svg-icon-primary'
                    />
                    <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                        Edit Goods Receive
                    </span>
                </div>
            </div>

            <div className="ml-12">
                <div className="card-body">
                    
                    <form onSubmit={purchaseSave}>
                        <div className="form-group row">
                            <label htmlFor="purchaseType" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Receive Type <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <select name="purchaseType" id="purchaseType" onChange={handleSelectOnChange} className="form-control form-control-sm" value={purchase.purchaseType}>
                                    <option value={'Local Purchase'}>Local Purchase</option>
                                    <option value={'LC'}>LC</option>
                                </select>
                            </div>
                        </div>
                        
                        <div className="form-group row">
                            <label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Project <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={project}
                                    onChange={handleProjectChange}
                                    options={projects}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idWarehouses" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Select Warehouse <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={warehouse}
                                    onChange={handleWarehouseChange}
                                    options={warehouses}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isDisabled={warehouses.length === 0}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idPo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select PO <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={po}
                                    onChange={handlePoChange}
                                    options={purchaseOrders}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idVendors" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Vendor <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={vendor}
                                    onChange={handleVendorChange}
                                    options={vendors}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isDisabled={purchase.purchaseType === 'Local Purchase' || purchase.purchaseType === 'LC'}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="purchaseDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Receive Date <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input type='date' name="purchaseDate" id="purchaseDate" onChange={handleInputOnChange} className="form-control form-control-sm" value={purchase.purchaseDate} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="creditDays" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Credit Days</label>
                            <div className="col-lg-5">
                                <input type='number' name="creditDays" id="creditDays" value={purchase.creditDays || ''} onChange={handleInputOnChange} className="form-control form-control-sm" readOnly />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="referenceNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Reference No</label>
                            <div className="col-lg-5">
                                <input type='text' name="referenceNo" id="referenceNo" onChange={handleInputOnChange} className="form-control form-control-sm"  value={purchase.referenceNo} disabled/>
                            </div>
                        </div>
                        {
                            purchase.purchaseType === 'LC' && (
                            <div className="form-group row mb-2">
                                <label htmlFor="lcNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>LC No <span className="required text-danger"></span></label>
                                <div className="col-lg-5">
                                    <input name="lcNo" id="lcNo" onChange={handleInputOnChange} className="form-control form-control-sm"  value={purchase.lcNo} readOnly/>
                                </div>
                            </div>
                            )
                        }
                        {
                            purchase.purchaseType === 'LC' && (
                            <div className="form-group row mb-2">
                                <label htmlFor="invoiceNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Commercial Invoice No <span className="required text-danger"></span></label>
                                <div className="col-lg-5">
                                    <input
                                        name="invoiceNo"
                                        id="invoiceNo"
                                        onChange={handleInputOnChange}
                                        className="form-control form-control-sm"
                                        value={purchase.invoiceNo}
                                        required={purchase.purchaseType === 'LC'}
                                    />
                                </div>
                            </div>
                            )
                        }
                        
                        <div className="form-group row mb-2">
                            <label htmlFor="chalanNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Chalan No <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input name="chalanNo" id="chalanNo" onChange={handleInputOnChange} className="form-control form-control-sm"  value={purchase.chalanNo} required />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="chalanDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Chalan Date</label>
                            <div className="col-lg-5">
                                <input type='date' name="chalanDate" id="chalanDate" onChange={handleInputOnChange} className="form-control form-control-sm"  value={purchase.chalanDate} />
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label htmlFor="remarks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Remarks</label>
                            <div className="col-lg-5">
                                <input name="remarks" id="remarks" onChange={handleInputOnChange} className="form-control form-control-sm"  value={purchase.remarks}/>
                            </div>
                        </div>

                        <br></br>
                        <Table size='sm' bordered hover>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }} className='text-center'>SL</th>
                                    <th style={{ width: '30%' }}>Item Name <span className='text-danger'>*</span> </th>
                                    <th style={{ width: '10%' }}>Rate</th>
                                    <th style={{ width: '10%' }}>Quantity</th>
                                    <th style={{ width: '10%' }}>Return Qty</th>
                                    <th style={{ width: '10%' }}>Amount</th>
                                    {/* <th style={{ width: '15%' }}></th> */}
                                </tr>
                            </thead>

                            <tbody>

                                {purchaseRows.map((row, index) => (
                                    <tr key={'item-'+index}>
                                        <td className='text-center'>{index + 1}</td>
                                        <td>
                                            <Select
                                                placeholder={row.itemName}
                                                onChange={(selectedOption) => handleItemChange(selectedOption, index)}
                                                options={items}
                                                className='sm'
                                                menuPosition="fixed"
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        height: '32px',
                                                        minHeight: '32px',
                                                    }),
                                                    container: (provided, state) => ({
                                                        ...provided,
                                                        height: '32px',
                                                    }),
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <input type="number" name="rate" value={row.rate} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm"  />
                                        </td>
                                        <td>
                                            <input type="number" name="quantity" value={row.quantity} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                            {row.poQuantity > 0 && (
                                                <> {/* Wrap in a fragment to avoid unnecessary DOM nodes */}
                                                    <small><strong>{row.poQuantity}</strong> ordered </small>
                                                    <small><strong>{row.receivedQuantity}</strong> previously received </small>
                                                    <small><strong>{row.returnedQuantity || 0}</strong> previously returned </small>
                                                    {(row.receivedQuantity - (row.returnedQuantity || 0)) >= row.poQuantity ? (
                                                        <small className='text-danger'>(PO Quantity already received)</small>
                                                    ) : (row.receivedQuantity - (row.returnedQuantity || 0)) > row.poQuantity ? (
                                                        <small className='text-danger'>(Received quantity exceeds PO quantity)</small>
                                                    ) : (
                                                        <small className='text-danger'><strong>{row.poQuantity - (row.receivedQuantity - (row.returnedQuantity || 0))}</strong> available</small>
                                                    )}
                                                </>
                                            )}
                                        </td>
                                        <td>
                                            <input type="number" name="returnQuantity" value={row.returnQuantity} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <input type="number" name="amount" readOnly value={row.amount} className="form-control form-control-sm" />
                                        </td>
                                        {/* <td>
                                            {
                                                purchaseRows.length > 1 &&
                                                <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteItem(index)}>
                                                    <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                                </button>
                                            }
                                            
                                            {index === purchaseRows.length - 1 && (
                                                <button type='button' className="btn btn-success btn-sm px-2 py-1" onClick={() => addItem(index)}>
                                                    <KTSVG path='/media/svg/icons/Navigation/Plus.svg' className='svg-icon-5 svg-icon-danger me-0' /> Add
                                                </button>
                                            )}
                                        </td> */}
                                    </tr>
                                ))}

                                <tr>
                                    <td colSpan={5} className='text-end'><b>Total Amount:</b></td>
                                    <td><b>{numberFormat(calculateTotalAmount())}</b></td>
                                </tr>
                               
                            </tbody>

                        </Table>
                        
                        <div className="row mt-4">
                            <div className="col-6"></div>
                            <div className="col-6">
                                <div className='notice bg-light-primary rounded border-primary border border-dashed h-lg-100 p-6'>
                                    <div className="row mt-2">
                                        <div className="col-md-5"><strong>Total Amount: </strong></div>
                                        <div className="col-md-4">
                                            {numberFormat(calculateTotalAmount())}
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-5"><strong>VAT: </strong></div>
                                        <div className="col-md-4">
                                            <div className="input-group input-group-sm mb-3">
                                                <input 
                                                    type='number' 
                                                    name="vatPercentage" 
                                                    value={purchase.vatPercentage || ''} 
                                                    onChange={handleVatOnChange} 
                                                    className="form-control form-control-sm" 
                                                    min={0} 
                                                    step={'any'} 
                                                />
                                                <span className="input-group-text">%</span>
                                                <input 
                                                    type='number' 
                                                    name="vatAmount" 
                                                    id="vatAmount" 
                                                    value={purchase.vatAmount || 0} 
                                                    className="form-control form-control-sm" 
                                                    readOnly 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-5"><strong>TAX: </strong></div>
                                        <div className="col-md-4">
                                            <div className="input-group input-group-sm mb-3">
                                                <input 
                                                    type='number' 
                                                    name="taxPercentage" 
                                                    value={purchase.taxPercentage || ''} 
                                                    onChange={handleTaxOnChange} 
                                                    className="form-control form-control-sm" 
                                                    min={0} 
                                                    step={'any'} 
                                                />
                                                <span className="input-group-text">%</span>
                                                <input 
                                                    type='number' 
                                                    name="taxAmount" 
                                                    id="taxAmount" 
                                                    value={purchase.taxAmount || 0} 
                                                    className="form-control form-control-sm" 
                                                    readOnly 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-5"><strong>Net Amount: </strong></div>
                                        <div className="col-md-4">
                                            {numberFormat(purchase.purchaseAmount || calculateTotalAmount())}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-12 text-center">
                                <button type="submit" className="btn btn-sm btn-primary me-2">
                                    <span>  Submit</span>
                                </button>
                                <Link to='/purchase' type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                            </div>
                        </div>

                        {/* <pre>{JSON.stringify(purchase, null, 2)}</pre>
                        <pre>{JSON.stringify(purchaseRows, null, 2)}</pre> */}
                    </form>

                </div>
            </div>
        </div>

    )
}

export default PurchaseEdit
